module.exports = __webpack_public_path__ + "media/images/game_icon/zh-cn/AB1043-6f3a04896535de180584a0b395159582.png";